import { breakpointOrder, mediaQueries } from "../tokens/breakpoints.js";
import { useCallback, useSyncExternalStore } from "react";
//#region src/lib/useMediaQuery.ts
var canMatch = () => typeof window !== "undefined" && typeof window.matchMedia === "function";
/**
* Whether a media query matches, kept current as it changes. SSR-safe: on the server,
* and during hydration, it returns `serverValue` (default `false`), then the real value.
*
* Prefer CSS (`@media (--md-up)`) for layout; use this when behaviour differs, such as
* a sidebar that is persistent on desktop and a drawer below it.
*/
function useMediaQuery(query, serverValue = false) {
	const subscribe = useCallback((onChange) => {
		if (!canMatch()) return () => {};
		const list = window.matchMedia(query);
		list.addEventListener("change", onChange);
		return () => list.removeEventListener("change", onChange);
	}, [query]);
	const getSnapshot = () => canMatch() ? window.matchMedia(query).matches : serverValue;
	return useSyncExternalStore(subscribe, getSnapshot, () => serverValue);
}
/**
* The largest breakpoint the viewport is at or above, or `base` below `sm`. On the
* server it returns `serverValue` (default `base`, so markup starts mobile-first).
*/
function useBreakpoint(serverValue = "base") {
	const serverIndex = breakpointOrder.indexOf(serverValue);
	const index = breakpointOrder.map((name, index) => useMediaQuery(mediaQueries.up[name], index <= serverIndex)).lastIndexOf(true);
	return index === -1 ? "base" : breakpointOrder[index];
}
//#endregion
export { useBreakpoint, useMediaQuery };

//# sourceMappingURL=useMediaQuery.js.map